var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCol',{attrs:{"md":"8","lg":"6"}},[_c('CCardGroup',[_c('CCard',{staticClass:"p-4"},[_c('CCardBody',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }